import React from "react";
import { PrintRecord } from "../../BlakeData/Types";
// import { ActiveIndex } from "./Types";
import { Link } from "react-router-dom";
import { API } from "../../BlakeData";

// import { ReactComponent as CloseIcon } from "./close-icon.svg";
// import { ReactComponent as LinkAwayIcon } from "./link-away.svg";

interface EditionHoverBoxProps {
    totalWidth: number;
    hoverItemWidth: number;
    selectedItemIndex: number;
    paletteWidth: number;
    padding: number;
    print: PrintRecord;
    clearActiveIndex: () => void;
}

/**
 * A preview of an image that appears when hovering over an palette from 
 * within an edition
 * @param props 
 */
export function EditionHoverBox(props: EditionHoverBoxProps) {

    const hoverItemWidth = props.hoverItemWidth;
    // const [preloaded, setPreloaded] = useState<boolean>(false)

    let offset = props.selectedItemIndex * (props.paletteWidth + props.padding) - props.hoverItemWidth / 2
    // offset = Math.max(0, offset);
    // offset = Math.min(width - hoverItemWidth, offset);

    // if (width < hoverItemWidth) {
    //     hoverItemWidth = 100;
    //     offset = (width / 2) - (hoverItemWidth / 2)
    // }

    if (!props.print) { return (null) }

    // // preload the query so it doesn't take as long 
    // // to run when the visit button is clicked
    // // yes, this is a hack
    // if (!preloaded) {
    //     API.getPrintsByGroupID(props.print.groupID)
    //         .then((prints: Array<PrintRecord>) => {
    //             console.log("preloaded", prints)
    //             setPreloaded(true);
    //         });
    // }


    return (
        <div
            // onMouseMove={(evt) => { 
            //     console.log("Hoverbox mouse move", evt.target);
            //     evt.stopPropagation(); 
            //     evt.preventDefault();
            // }}
            style={{
                width: hoverItemWidth,
                // height: hoverItemHeight,
                left: `${offset}px`
            }}
            className="hover-box">
            <Link to={`/group/view/${props.print.groupID}/${props.print.id}`}>
                <div className="hover-screen"></div>
            </Link>
            {/*             
                <div className="hover-screen"></div>
            <div className="thumbnail-button-tray">
                <div onClick={() => props.clearActiveIndex()} className="button-icon"><CloseIcon /></div>

                <Link to={`/group/view/${props.print.groupID}/${props.print.id}`}>
                    <div className="button-icon"><LinkAwayIcon /></div>
                </Link>
            </div> 
        */}

            <img
                alt={`${props.print.id}`}
                className="print-thumbnail"
                //src={`${process.env.PUBLIC_URL}/img/${props.print.id}.100.jpg`}>
                src={API.getThumbnailURL(props.print)}
            />
        </div>
    );

}